angular.module('bbl.module.users.routing', [])
  .config(['$routeProvider', usersRoutingSetup]);

function usersRoutingSetup($routeProvider) {
  var resolveAuth = {
    profile: ["Auth", function(Auth) {
      return Auth.getProfile().then(function(response) {
        return response.data.profile;
      });
    }], permissions: ["Auth", "$q", function(Auth, $q) {
      return Auth.getPermission().then(function(response) {
        if(response.data.permission_level !== 3) {
          return $q.reject({ authenticated: false });
        }
        return response.data.permission_level;
      });
    }]
  };
  
  var profileRoute = {
    templateUrl: 'users-template.html',
    controller: 'UsersController',
    resolve: resolveAuth
  };

  var inviteUserRoute = {
    templateUrl: 'invite-template.html',
    controller: 'UsersController',
    invitedLayout: true
  };

  $routeProvider.when('/manage-users', profileRoute)
    .when('/invite/:token?', inviteUserRoute);
}


/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/users/users.routing.js
 ** module id = 381
 ** module chunks = 0
 **/